const genAnswer = function (qu, value, refItem) {
  const optionList = qu.optionList
  const otherOption = optionList.find(opt => opt.id === value) || {}
  return [{
    descId: refItem.id,
    answer: value,
    otherAnswer: otherOption.otherValue || ''
  }]
}

const setAnswer = function (qu, valueMap, otherAnswerMap, extendsDataMap, questions) {
  const { descList, descIndex } = this
  const descObj = descList[descIndex]
  if (descObj) {
    const id = descObj.id
    let value = valueMap[id] || ''
    if (value) {
      value = value[0]
      if (this.optionList.find(item => item.id === value)) {
        this.optionList.find(item => item.id === value).otherValue = otherAnswerMap[id] || ''
      }
    }
    descObj.value = value
  }
}

const answer = {
  genAnswer,
  setAnswer
}

export default answer



// WEBPACK FOOTER //
// ./src/components/editor/RadioBoxGroup/answer.js